<template url="https://vuejs.org">
  <div>
    <b-modal id="modal-1" title="Share" centered hide-footer>
      <div class="d-flex justify-content-around mb-8">
        <a
          rel="nofollow"
          :href="`https://facebook.com/share.php?u=${copy}`"
          target="_black"
        >
          <img
            class="w-10 h-10 cursor-pointer"
            src="../../../assets/icons/facebook.svg"
            alt=""
          />
        </a>
        <a
          :href="`https://linkedin.com/sharing/share-offsite/?url=${copy}`"
          target="_black"
        >
          <img
            class="w-10 h-10 cursor-pointer"
            src="../../../assets/icons/Linkedin.svg"
          />
        </a>
        <a :href="`mailto:?body=${copy}`" target="_black">
          <img
            class="w-10 h-10 cursor-pointer"
            src="../../../assets/icons/Mail.svg"
            alt=""
          />
        </a>
        <a :href="`https://api.whatsapp.com/send?text=${copy}`" target="_black">
          <img
            class="w-10 h-10 cursor-pointer"
            src="../../../assets/icons/Whatsapp.svg"
            alt=""
          />
        </a>
        <a
          :href="`https://twitter.com/share?text=google&url=${copy}`"
          target="_black"
        >
          <img
            class="w-10 h-10 cursor-pointer"
            src="../../../assets/icons/Twitter.svg"
            alt=""
          />
        </a>
      </div>

      <!-- <div class="container" ref="modalBody">
        <input type="text" v-model="message" />
        <button type="button" @click="doCopy(message)">Copy!</button>
      </div> -->
      <b-input-group size="md" class="mb-2">
        <b-form-input
          type="text"
          :class="{ inputstyle: applystyle }"
          v-model="copy"
        ></b-form-input>
        <b-input-group-prepend
          ref="modalBody"
          type="button"
          is-text
          class="cursor-pointer textstyle"
          @click="doCopy(copy)"
        >
          COPY
        </b-input-group-prepend>
      </b-input-group>
    </b-modal>

    <div class="bg-white relative md:pt-32 lg:pt-32 pt-24">
      <div class="absolute left-0 top-1/2 md:block lg:block hidden">
        <img
          src="../../../assets/images/bg-des/bg-half-tri-blogdetails.svg"
          alt="bg-polygon"
          class=""
        />
      </div>
      <div class="md:px-12 lg:px-16 px-0 flex flex-wrap">
        <div class="md:w-3/5 lg:w-3/4 w-full lg:px-6 md:px-2">
          <div class="w-full relative z-index1">
            <div class="">
              <img
                v-if="pageData.image"
                :src="$imageURL + '/' + pageData.image"
                alt="Blogchair"
                class="w-full rounded-lg h510px-res object-cover"
                @error="hasError = true"
              />
              <img
                v-else
                :src="defaultImage"
                alt="Blogchair"
                class="w-full rounded-lg h510px-res object-cover"
                @error="hasError = true"
              />
            </div>

            <div
              class="absolute right-16 -bottom-32 trans-rotate-31-blog z-index--1 md:block lg:block hidden"
            >
              <img
                src="../../../assets/images/bg-des/team-bg-t1.svg"
                alt="bg-polygon"
                class=""
              />
            </div>
          </div>
          <!-- contentLock: {{ contentLock }} -->
          <div class="md:mt-10 lg:mt-10 mt-6">
            <div class="flex gap-1 justify-between">
              <p class="fsize32 sm-fsize20px font-bold text-black">
                {{ pageData.title }}
              </p>
              <div class="mt-4 flex items-center gap-2">
                <img
                  v-b-modal.modal-1
                  @click="dialogVisible = true"
                  src="./../../../assets/images/share.png"
                  alt="ShareIcon"
                  class="lg:h-5 lg:w-5 md:h-6 md:w-6 w-4 h-4 cursor-pointer"
                />
                <feather-icon
                  icon="BookmarkIcon"
                  class="cursor-pointer mr-2"
                  :svgClasses="bookmarkStatus ? 'wishlistActive' : ''"
                  @click="handleBookmarkClick"
                />
              </div>
            </div>
            <p
              class="fsize20 sm-fsize16 font-semibold text-black"
              v-if="pageData.doctors && pageData.doctors[0]"
            >
              Medically reviewed by:<span
                class="cursor-pointer"
                @click="handleScroll"
              >
                {{ pageData.doctors[0].name }}</span
              >
            </p>
            <div class="md:flex lg:flex md:mt-2 lg:mt-2 mt-2">
              <!-- <p
              class="
                font-normal
                fsize18px
                text-black
                font-bold
                md:block
                lg:block
                hidden
              "
              >
              Phasellus nec feugiat vitae, pharetra
              </p> -->
              <p class="fsize18 sm-fsize16 clr777">
                {{ new Date(this.pageData.date).toDateString() }}
              </p>
            </div>
            <div class="">
              <p class="font-semibold fsize14 text-primary">
                Listen to this Blog:
              </p>
              <div class="mt-2">
                <TextToSpeech
                  :text="
                    convertToPlain(
                      `<p>${pageData.title}.</p>` + ' ' + pageData.html
                    )
                  "
                  :rate="1"
                  :pitch="1"
                />
              </div>
            </div>
          </div>

          <div class="w-full md:mt-6 lg:mt-6 mt-6">
            <div class="hrlineblogspage"></div>
          </div>
          <!-- <div v-html="pageData.html" class="html1 py-4 strong"></div> -->

          <div class="pb-4" @contextmenu.prevent>
            <quill-editor
              class="custeditor"
              :disabled="true"
              v-model="pageData.html"
              :options="editorOption"
            />
          </div>
        </div>
        <div
          class="md:w-2/5 lg:w-1/4 w-full px-6 md:block lg:block hidden h-600px overflow-auto blogs"
        >
          <RelatedBlogItem
            :item="item"
            v-for="(item, index) in relatedBlogData"
            :key="index"
          />
          <div class="flex justify-center">
            <div
              class="underline cursor-pointer text-primary"
              @click="handleClick('insights-blogs')"
            >
              View All
            </div>
          </div>
        </div>
        <div
          class="px-6 w-full mt-4"
          v-if="pageData.authors && pageData.authors[0]"
        >
          <h2 class="text-primary fsize22 sm-fsize18 font-bold">
            About the Author
          </h2>
          <div
            class="lg:flex md:flex items-center gap-6 mt-4 border-white rounded w-full py-2"
          >
            <div class="lg:w-1/12 md:w-2/12 w-full">
              <img
                :src="
                  pageData.authors[0].image
                    ? `${$imageURL}/${pageData.authors[0].image}`
                    : require(`@/assets/images/AuthorImage.jpg`)
                "
                class="lg:h-24 lg:w-24 md:h-24 md:w-24 w-20 h-20 bg-primary rounded-full border mx-auto object-cover"
                :alt="pageData.authors[0].name"
              />
              <!-- <img
                v-if="pageData.authors[0].image"
                src="../../../assets/images/Sebati_Iyengar.jpg"
                alt=""
                class="h-24 w-24 bg-primary rounded-full border mx-auto"
              />
              <img
                v-if="!pageData.authors[0].image"
                src="../../../assets/images/Sebati_Iyengar.jpg"
                alt=""
                class="h-24 w-24 bg-primary rounded-full border mx-auto"
              /> -->
            </div>
            <div class="lg:w-11/12 md:w-10/12 w-full">
              <p class="fsize20 text-333 font-bold">
                {{ pageData.authors[0].name }}
              </p>
              <p class="fsize16" v-if="pageData.authors[0].designation">
                {{ pageData.authors[0].designation }}
              </p>
            </div>
          </div>
        </div>
        <div class="border my-6 rounded-lg p-3 lg:mb-12 md:mb-12 mx-5">
          <h3 class="fsize22 font-semibold">Disclaimer:</h3>
          <p class="leading-tight fsize16 mt-3 clr-2e2e2e">
            The information provided on this website is for educational purposes
            only and is not intended to be a substitute for professional medical
            advice, diagnosis, or treatment.
          </p>
          <p class="fsize16 mt-2 clr-2e2e2e">
            Readers should seek professional medical advice and treatment for
            any specific health-related issues."
          </p>
          <p class="fsize16 mt-2 clr-2e2e2e">
            The information presented on this website is provided 'as is'
            without any representations or warranties, express or implied. The
            website owner and contributors disclaim all liability for any
            damages or losses arising from the use of this information.
          </p>
        </div>
        <div
          class="px-6 w-full mt-4"
          v-if="pageData.doctors && pageData.doctors[0]"
          id="doctor-detail"
        >
          <h2 class="text-primary fsize24 sm-fsize20 font-bold">
            About the Doctor
          </h2>
          <div
            class="flex items-center gap-6 mt-4 border-white rounded shadow-xl w-full px-4 py-2"
          >
            <div class="lg:w-2/12 md:w-2/12 w-1/3">
              <img
                :src="
                  pageData.doctors[0].image
                    ? `${$imageURL}/${pageData.doctors[0].image}`
                    : require(`@/assets/images/AuthorImage.jpg`)
                "
                class="lg:h-24 lg:w-24 md:h-24 md:w-24 w-20 h-20 bg-primary rounded-full border mx-auto"
                :alt="pageData.doctors[0].name"
              />
            </div>
            <div class="w-11/12">
              <p class="fsize20 text-333 font-bold">
                {{ pageData.doctors[0].name }}
                <span v-if="pageData.doctors[0].degree"
                  >({{ pageData.doctors[0].degree }})</span
                >
              </p>
              <p class="fsize16" v-if="pageData.doctors[0].description">
                {{ pageData.doctors[0].description }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="bge3ceff-opa rounded-t-5555 mt-12">
        <DownloadApp />
        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import DownloadApp from "../../home/components/DownloadApp.vue";
import RelatedBlogItem from "./components/RelatedBlogItem";
import Footer from "../../Footer.vue";
import { mapState } from "vuex";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import TextToSpeech from "./components/TextToSpeech.vue";
import FeatherIcon from "../../../components/FeatherIcon.vue";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.bubble.css";

export default {
  components: {
    DownloadApp,
    Footer,
    RelatedBlogItem,
    TextToSpeech,
    FeatherIcon,
    quillEditor,
  },
  data() {
    return {
      search: "",
      contentLock: false,
      applystyle: false,
      copy: "",
      dialogVisible: false,
      editModal: false,
      relatedPages: [],
      hasError: false,
      pageData: {},
      blogId: "61adf7f010718313e80bcc4b",
      defaultImage:
        this.$imageURL + "/caregiversaathi/default/dummy%20image.jpg",
      defaultAuthor:
        this.$imageURL + "/caregiversaathi/default/dummy%20image.jpg",
      editorOption: {
        theme: "bubble",
        readOnly: true,
        placeholder: "",
        modules: {
          toolbar: false,
        },
      },
      props: {
        itemId: {
          type: String,
          required: true,
        },
        userId: {
          type: String,
          required: false,
        },
        type: {
          type: String,
          default: "page",
        },
        // initialBookmarkState: {
        //   type: Boolean,
        //   default: false,
        // },
      },
      // isBookmarked: this.initialBookmarkState,
      // isBookmarked: false,
      // bookmarkId: null,
      bookdata: {},
      bookmarks: {},
      // meta_title: "",
      // meta_description: "",
      // meta_canonical: "",
      // meta_keyword: "",
    };
  },
  // metaInfo() {
  //   return {
  //     title: this.meta_title,
  //     meta: [
  //       {
  //         name: "keyword",
  //         content: this.meta_keyword,
  //       },
  //       {
  //         name: "description",
  //         content: this.meta_description,
  //       },
  //       {
  //         rel: "canonical",
  //         href: this.meta_canonical,
  //       },
  //     ],
  //   };
  // },
  watch: {
    search: {
      handler: _.debounce(async function (val) {
        await this.getpagebycategoryForRelated();
      }, 500),
    },
    $route() {
      this.contentLock = false;
      this.getMemberAndUser();
      this.init();
      // console.log("route");

      this.hasError = false;
    },
    // pageData(page) {
    //   this.isContentlock();
    // },
  },
  computed: {
    ...mapState("cms", {
      page: "page",
      categorywisepages: "categorywisepages",
    }),
    // ...mapState("subscribe", {
    //   get_all_membership: "get_all_membership",
    // }),
    ...mapState("auth", { user: "user" }),
    ...mapState("auth", { getUserByUserId: "getUserByUserId" }),
    ...mapState("bookMarks", {
      getbookMarks: "getbookMarks",
    }),
    //     title() {
    //       return this.page.title;
    //     },
    //     subTitle() {
    //       return this.page.subTitle;
    //     },
    //     htmlContent1() {
    //       return this.page.html;
    //     },
    //     image() {
    //  return `${this.$imageURL}/${this.page.image}`;

    //     },
    //     date() {
    //       return new Date(this.page.createdAt).toDateString();
    //     },
    relatedBlogData() {
      let relatedData = [];
      if (
        this.categorywisepages &&
        this.categorywisepages.data &&
        this.categorywisepages.data.length > 0
      ) {
        this.categorywisepages.data.forEach((blog) => {
          if (relatedData.length === 10) {
            return relatedData;
          }
          if (blog._id !== this.pageData._id) {
            relatedData.push(blog);
          }
        });
      }
      // console.log(relatedData, "relatedData");
      return relatedData;
    },
    bookmarkStatus() {
      return this.bookmarks[this.pageData._id] || false;
    },
  },
  methods: {
    async checkBookmarkStatus() {
      const payload = {
        _id: this.user._id,
        type: "page",
      };
      try {
        const response = await this.$store.dispatch(
          "bookMarks/GetBookmarks",
          payload
        );

        response.data.forEach((bookmark) => {
          this.$set(this.bookmarks, bookmark.itemId, bookmark._id);
        });
        this.bookdata = response.data;
        // console.log("BookData", this.bookdata);
      } catch (error) {
        console.error("Failed to check bookmark status:", error);
      }
    },

    async handleBookmarkClick() {
      if (!this.user._id) {
        this.$notify.error("Please log in to save bookmark items.");
        return;
      }

      const itemId = this.pageData._id;
      const bookmarkId = this.bookmarks[itemId];

      try {
        let response;
        if (bookmarkId) {
          response = await this.$store.dispatch("bookMarks/DeleteBookmark", {
            _id: bookmarkId,
          });

          if (response.code === 200) {
            this.$set(this.bookmarks, itemId, null);
            this.$notify.success("Bookmark removed.");
          } else {
            this.$notify.error("Failed to remove bookmark.");
          }
        } else {
          response = await this.$store.dispatch("bookMarks/SaveBookmark", {
            userId: this.user._id,
            itemId,
            type: "page",
          });

          if (response.code === 200) {
            // Store the new bookmark _id for the itemId
            this.$set(this.bookmarks, itemId, response.data._id);
            this.$notify.success("Bookmark added.");
          } else {
            this.$notify.error("Failed to add bookmark.");
          }
        }
      } catch (error) {
        console.error("Error toggling bookmark:", error);
        this.$notify.error("An error occurred. Please try again.");
      }
    },

    handleClick(name) {
      this.$router.push({ name: name });
    },
    convertToPlain(html) {
      // Create a new div element
      var tempDivElement = document.createElement("div");
      // Set the HTML content with the given value
      tempDivElement.innerHTML = html;
      // Retrieve the text property of the element
      return tempDivElement.textContent || tempDivElement.innerText || "";
    },
    handleScroll() {
      const el = document.getElementById("doctor-detail");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    isContentlock() {
      if (this.page && this.page.onlyRegistered === true) {
        // console.log(this.page.onlyRegistered);
        if (this.isNotLoggedIn()) {
          this.contentLock = true;
        } else {
          this.contentLock = false;
        }
      }

      if (
        this.page &&
        this.page.memberships &&
        this.page.memberships.length > 0
      ) {
        let result = this.page.memberships.some(
          (membership) =>
            membership._id === this.getUserByUserId.currentMembership
        );
        // console.log(
        //   result,
        //   this.page.memberships,
        //   this.getUserByUserId.currentMembership
        // );
        if (!result) {
          this.contentLock = true;
        } else {
          this.contentLock = false;
        }
      } else {
        this.contentLock = false;
      }
    },
    isObjEmpty(value) {
      if (Object.keys(value).length === 0 && value.constructor === Object) {
        return true;
      }
      return false;
    },
    async getPage() {
      const slug = this.$route.params.slug
        .replace(/-/g, " ")
        .replace(/_/g, "-");
      const data = await this.$store.dispatch("cms/getPage", slug);
      if (this.isObjEmpty(data.data)) {
        this.$swal.fire({
          text: "Blog is not Avaliable!",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return this.$router.push({ name: "insights-blogs" });
      }
      this.pageData = data.data;
      // this.meta_title = this.pageData.metaTitle;
      // this.meta_description = this.pageData.metaDesc;
      // this.meta_canonical = this.pageData.metaCanonicalTag;
      // this.meta_keyword = this.metaKeyword;
    },
    async getpagebycategoryForRelated() {
      let payload = {
        id: this.blogId,
        offset: 0,
        isNotLoggedIn: this.isNotLoggedIn(),
        updatedAt: true,
      };
      if (this.search != "") {
        Object.assign(payload, { search: this.search.trim() });
      }
      let data = await this.$store.dispatch(
        "cms/GetPagesbyCategoryForBlog",
        payload
      );
    },
    isNotLoggedIn() {
      if (sessionStorage.getItem("token")) {
        return false;
      } else {
        return true;
      }
    },

    async init() {
      if (this.categorywisepages.hasOwnProperty("data")) {
        // console.log("FOUND: " + this.categorywisepages);
        await this.getPage();
        this.isContentlock();
      } else {
        // console.log("NOT FOUND" + this.categorywisepages);
        this.getpagebycategoryForRelated();
        await this.getPage();
        this.isContentlock();
      }
    },
    doCopy(copy) {
      this.$copyText(copy, this.$refs.modalBody);
      this.applystyle = true;
      // swal.fire({ title: "", icons: "success" });
      this.$swal.fire({
        text: "Link copied to clipboard",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
        timer: 2000,
      });
    },
    destroyed() {
      clearInterval((this.applystyle = false));
    },
    async getMemberAndUser() {
      try {
        if (this.user && this.user._id) {
          let getUserPayload = {
            userId: this.user._id, ///
          };
          const getUser = await this.$store.dispatch(
            "auth/getUserByUserId",
            getUserPayload
          );
          // console.log("GETUSER:", this.getUserByUserId);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    // this.init();
    this.checkBookmarkStatus();
    // this.copy = window.location.href;
    this.copy = `${process.env.VUE_APP_BASE_URL_CORE_API}cms/page/blogGet/${this.$route.params.slug}`;
  },
  created() {
    this.checkBookmarkStatus();
    this.getMemberAndUser();
    this.init();
  },
};
</script>
<style>
.html1 > p {
  margin-bottom: 10px;
}
.modal-header {
  height: 1rem;
}
.modal-header .close {
  margin: -26px -1rem auto;
}
.swal2-container:not(.swal2-top):not(.swal2-top-start):not(.swal2-top-end):not(
    .swal2-top-left
  ):not(.swal2-top-right):not(.swal2-center-start):not(.swal2-center-end):not(
    .swal2-center-left
  ):not(.swal2-center-right):not(.swal2-bottom):not(.swal2-bottom-start):not(
    .swal2-bottom-end
  ):not(.swal2-bottom-left):not(.swal2-bottom-right):not(.swal2-grow-fullscreen)
  > .swal2-modal {
  margin-top: 0rem;
  height: 8px;
  width: 13rem;
}
.swal2-styled.swal2-confirm {
  display: none !important;
}
.swal2-html-container {
  position: absolute;
  top: 8px;
  left: 25px;
  font-size: 15px;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group
  > .input-group-prepend:first-child
  > .input-group-text:not(:first-child) {
  background: #4f0a4b;
  color: white;
}

.disable-tailwind {
  all: unset !important;
}

.strong h1 {
  font-size: 2em !important;
  font-weight: bolder !important;
}
.strong h2 {
  font-size: 1.5em !important;
  font-weight: bolder !important;
}
.strong h3 {
  font-size: 1.17em !important;
  font-weight: bolder !important;
}
.strong h4 {
  font-size: 1em !important;
  font-weight: bolder !important;
}
.strong h5 {
  font-size: 0.83em !important;
  font-weight: bolder !important;
}
.strong h6 {
  font-size: 0.67em !important;
  font-weight: bolder !important;
}
.text-333 {
  color: #333;
}
.custeditor .ql-editor {
  padding: 12px 0px;
  user-select: none; /* Prevent text selection */
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  pointer-events: none; /* Prevents interaction with content */
}
.wishlistActive {
  fill: #4f0a4b;
  stroke: #4f0a4b;
}
</style>
